import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosOrderObservationsService } from 'src/app/@core/services/pos-order-observations.service';
import { PosOrderObservationsComponent } from './pos-order-observations.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';



@NgModule({
  declarations: [PosOrderObservationsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),

  ],
  providers: [PosOrderObservationsService],
  exports: [PosOrderObservationsComponent]
})
export class PosOrderObservationsModule { }
